import type { ListType } from '../models/app';
import { AdjustmentType, NeedLoveFormType, NeedLoveStatusOfComplaint, RefundApprovedOrDeny } from '@/models/needLove';

export const needLoveNotUsingServiceReasonList: ListType[] = [
  { id: 1, key: 'Found alternative transportation', label: 'Found alternative transportation' },
  { id: 2, key: 'Not going out or traveling', label: 'Not going out or traveling' },
  { id: 3, key: "Medical issues and can't use the service", label: "Medical issues and can't use the service" },
  { id: 4, key: "Can't afford to use the services", label: "Can't afford to use the services" },
  { id: 5, key: 'Mistook us for Uber/Lyft', label: 'Mistook us for Uber/Lyft' },
  { id: 6, key: 'Only needed us one-time', label: 'Only needed us one-time' },
  { id: 7, key: 'Mistook our services for something else', label: 'Mistook our services for something else' },
  { id: 8, key: 'Someone else signed them up', label: 'Someone else signed them up' },
  { id: 9, key: "Don't feel safe/comfortable using the service", label: "Don't feel safe/comfortable using the service" },
  { id: 10, key: 'Can drive themselves', label: 'Can drive themselves' },
  { id: 11, key: 'Other', label: 'Other' },
];

export const needLoveAlternativeTransportationsList: ListType[] = [
  { id: 1, key: 'Family/Friend is driving them', label: 'Family/Friend is driving them' },
  { id: 2, key: 'Moved to assisted living facility', label: 'Moved to assisted living facility' },
  { id: 3, key: 'City transit or another more afford service', label: 'City transit or another more afford service' },
  { id: 4, key: 'Free/insurance transportation service', label: 'Free/insurance transportation service' },
  { id: 5, key: 'Caregiver who will be driving them', label: 'Caregiver who will be driving them' },
];

export const complaintTypeList: ListType[] = [
  {
    id: 1,
    key: NeedLoveFormType.CallerExperiencedTechnicalIssue,
    label: 'Caller Experienced Technical Issues',
  },
  { id: 2, key: NeedLoveFormType.CallerPaidInCash, label: 'Caller Paid In Cash' },
  { id: 3, key: NeedLoveFormType.CancellationFee, label: 'Cancellation Fee' },
  { id: 4, key: NeedLoveFormType.CustomerInvolvedAccident, label: 'Customer was involved in an accident' },
  {
    id: 5,
    key: NeedLoveFormType.DriverCancelledButTookCaller,
    label: 'Driver Cancelled But Took Caller Anyway',
  },
  {
    id: 6,
    key: NeedLoveFormType.DriverDoesNotWantToDriveForGoGo,
    label: 'Driver does not want to drive for GoGo',
  },
  { id: 7, key: NeedLoveFormType.DriverPhysically, label: 'Driver physically/sexually assaulted customer' },
  { id: 8, key: NeedLoveFormType.DriverReportingCustomerIssue, label: 'Driver Reporting Customer Issue' },
  {
    id: 9,
    key: NeedLoveFormType.DriverWasNiceButDrivingWasTooFast,
    label:
      'Driver Was Nice, But Their Driving Was Too Fast and/or Their Stops Were Too Abrupt and/or For Some Other Reason Their Driving Made The Older Adult Uncomfortable',
  },
  {
    id: 10,
    key: NeedLoveFormType.DriverWasRudeOrRefused,
    label: 'Driver Was Rude/Refused to Move/Kick Them Out/Other Behavioral Issues',
  },
  { id: 11, key: NeedLoveFormType.DriverCarWasDirty, label: "Driver's Car Was Dirty" },
  { id: 12, key: NeedLoveFormType.FalseTrip, label: 'False Trip' },
  { id: 13, key: NeedLoveFormType.FareReview, label: 'Fare Review' },
  { id: 14, key: NeedLoveFormType.LostItem, label: 'Lost Item' },
  {
    id: 15,
    key: NeedLoveFormType.PharmacySpecialRequestAttemptFee,
    label: 'Pharmacy/Special Request Attempt Fee',
  },
  { id: 16, key: NeedLoveFormType.RefundMonthlyMembershipFee, label: 'Refund Monthly Membership Fee' },
  { id: 17, key: NeedLoveFormType.UnexpectedSurge, label: 'Unexpected Surge' },
  { id: 18, key: NeedLoveFormType.WantsToCloseAccount, label: 'Wants to Close Account' },
];

export const statusOfComplaintList: ListType[] = [
  { id: 1, key: NeedLoveStatusOfComplaint.SelectOne, label: 'Select One' },
  { id: 2, key: NeedLoveStatusOfComplaint.WaitingOnUberLyft, label: 'Waiting on Uber/Lyft' },
  { id: 3, key: NeedLoveStatusOfComplaint.NoRefundOrCredit, label: 'No refund or credit' },
  { id: 4, key: NeedLoveStatusOfComplaint.Refunded, label: 'Refunded - see notes' },
  { id: 5, key: NeedLoveStatusOfComplaint.AdditionalActionNeeded, label: 'Additional action needed' },
  { id: 6, key: NeedLoveStatusOfComplaint.LeftVoicemail, label: 'Left a voicemail' },
  { id: 7, key: NeedLoveStatusOfComplaint.LeftSecondVoicemail, label: 'Left a 2nd voicemail' },
  { id: 8, key: NeedLoveStatusOfComplaint.RideCreditIssued, label: 'Ride credit issued' },
  { id: 9, key: NeedLoveStatusOfComplaint.ResolvedButNotCalledBack, label: 'Resolved but not called back' },
  { id: 10, key: NeedLoveStatusOfComplaint.WaitingOnUpperManagement, label: 'Waiting on Upper Management' },
  { id: 11, key: NeedLoveStatusOfComplaint.NeedToCollect, label: 'Need to collect' },
  { id: 12, key: NeedLoveStatusOfComplaint.ResolvedButFollowUpWithUsOp, label: 'Resolved but follow up with US op' },
  {
    id: 13,
    key: NeedLoveStatusOfComplaint.ResolvedButFollowUpWithFilipinoOperator,
    label: 'Resolved but follow up with Filipino Operator',
  },
  { id: 14, key: NeedLoveStatusOfComplaint.ResolvedButFollowUpWithMexicanOp, label: 'Resolved but follow up with Mexican op' },
];

export const needLoveCancelTypeList: ListType[] = [
  { id: 1, key: 'driver_canceled', label: 'Driver Cancellation' },
  { id: 2, key: 'operator_canceled', label: 'Operator Cancellation' },
  { id: 3, key: 'rider_canceled', label: 'Rider Cancellation' },
];

export const needLoveReturnAddressTypeList: ListType[] = [
  { id: 1, key: 'enter_address', label: 'Enter Address' },
  { id: 2, key: 'return_vendor_hub', label: 'Return the lost Items to the Vendor Hub' },
];

export const answerYesNoQuestionList: ListType[] = [
  { id: 1, key: 'yes', label: 'Yes' },
  { id: 2, key: 'no', label: 'No' },
];

export const deliveryTypeList: ListType[] = [
  { id: 1, key: 'pharmacy', label: 'Pharmacy Delivery' },
  { id: 2, key: 'special-request', label: 'Special Request' },
  { id: 3, key: 'other', label: 'Other' },
];

export const fareReviewReasonList: ListType[] = [
  { id: 1, key: "Customer doesn't recognize the ride or charge", label: "Customer doesn't recognize the ride or charge" },
  {
    id: 2,
    key: 'Disputing a wait time fee (driver arrived early, but customer got in on time)',
    label: 'Disputing a wait time fee (driver arrived early, but customer got in on time)',
  },
  {
    id: 3,
    key: 'Fare seems unusually high / customer believes they were overcharged',
    label: 'Fare seems unusually high / customer believes they were overcharged',
  },
  {
    id: 4,
    key: "Driver didn't end the trip on time, resulting in an inflated fare",
    label: "Driver didn't end the trip on time, resulting in an inflated fare",
  },
  {
    id: 5,
    key: 'Driver took a longer or incorrect route (intentionally or due to GPS error)',
    label: 'Driver took a longer or incorrect route (intentionally or due to GPS error)',
  },
  { id: 6, key: 'Customer was dropped off at the wrong location', label: 'Customer was dropped off at the wrong location' },
  {
    id: 7,
    key: 'Charged for a trip even though the customer had already been dropped off',
    label: 'Charged for a trip even though the customer had already been dropped off',
  },
  { id: 8, key: 'Other', label: 'Other' },
];

export const compensationList: ListType[] = [
  { id: 1, key: 'Credit', label: 'Credit' },
  { id: 2, key: 'Refund', label: 'Refund' },
  { id: 3, key: 'Other', label: 'Other' },
];

export const callDurationList: ListType[] = [
  { id: 1, key: 'Less than 5 mins', label: 'Less than 5 mins' },
  { id: 2, key: '5 ~ 10 mins', label: '5 ~ 10 mins' },
  { id: 3, key: '10 ~ 15 mins', label: '10 ~ 15 mins' },
  { id: 4, key: 'More than 15 mins', label: 'More than 15 mins' },
];

export const answerYesNoNaQuestionList: ListType[] = [
  { id: 1, key: 'Yes', label: 'Yes' },
  { id: 2, key: 'No', label: 'No' },
  { id: 3, key: 'N/A', label: 'N/A' },
];

export const customerMoodList: ListType[] = [
  { id: 1, key: 'Happy! - The Issue has been resolved!', label: 'Happy! - The Issue has been resolved!' },
  { id: 2, key: 'Still upset/angry - The issue has been resolved!', label: 'Still upset/angry - The issue has been resolved!' },
  { id: 3, key: 'Happy! - The issue needs more work.', label: 'Happy! - The issue needs more work.' },
  { id: 4, key: 'Still upset/angry - The issue needs more work.', label: 'Still upset/angry - The issue needs more work.' },
  { id: 5, key: 'Customer was unavailable / Left VM', label: 'Customer was unavailable / Left VM' },
];

export const refundApprovedDenyList: ListType[] = [
  { id: 1, key: RefundApprovedOrDeny.Refunded, label: 'Refunded per company policy' },
  { id: 2, key: RefundApprovedOrDeny.Approved, label: 'Yes, We approved refund/credit' },
  { id: 3, key: RefundApprovedOrDeny.Denied, label: 'No, We denied refund/credit' },
  { id: 4, key: RefundApprovedOrDeny.None, label: "N/A (This complaint didn't involve a refund/credit)" },
];

export const adjustmentTypeList: ListType[] = [
  { id: 1, key: AdjustmentType.Membership, label: 'Membership' },
  { id: 2, key: AdjustmentType.NonMembership, label: 'Non-Membership' },
  { id: 3, key: AdjustmentType.None, label: 'N/A' },
];

export const driverReporingComplaintReasonList: ListType[] = [
  { id: 1, key: 'Rider Was Rude or Abusive', label: 'Rider Was Rude or Abusive' },
  { id: 2, key: 'Rider Used Offensive Language', label: 'Rider Used Offensive Language' },
  { id: 3, key: 'Rider Threatened Driver', label: 'Rider Threatened Driver' },
  { id: 4, key: 'Rider Intoxicated or Under the Influence', label: 'Rider Intoxicated or Under the Influence' },
  { id: 5, key: 'Rider Caused Vehicle Damage', label: 'Rider Caused Vehicle Damage' },
  { id: 6, key: 'Rider Left a Mess in Vehicle', label: 'Rider Left a Mess in Vehicle' },
  { id: 7, key: 'Rider Requested Unauthorized Stops', label: 'Rider Requested Unauthorized Stops' },
  { id: 8, key: 'Rider Harassment/Inappropriate Behavior', label: 'Rider Harassment/Inappropriate Behavior' },
  { id: 9, key: 'Other', label: 'Other' },
];
